import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-float-label" }
const _hoisted_2 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.lovsManagementParamsDialogDescriptor.dialog.style,
    header: _ctx.$t('managers.lovsManagement.dependenciesTitle'),
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode === 'preview' ? _ctx.$emit('preview') : _ctx.$emit('test')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.mode === 'preview' ? _ctx.$t('managers.lovsManagement.preview') : _ctx.$t('managers.lovsManagement.test')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dependenciesList, (dependency, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("p", null, _toDisplayString(_ctx.$t(_ctx.lovsManagementParamsDialogDescriptor.info[dependency.type])), 1),
          _createVNode("div", null, [
            _createVNode("span", _hoisted_1, [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                type: "text",
                modelValue: dependency.value,
                "onUpdate:modelValue": ($event: any) => (dependency.value = $event),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode("label", _hoisted_2, _toDisplayString(dependency.name), 1)
            ])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "header", "visible"]))
}